import { prop } from 'datx';
import { inject } from 'dependable-react';
import { isEmpty } from 'lodash';
import { computed, observable } from 'mobx';

import { MoreMagicType } from '../../enums/MoreMagicType';
import { I18N_TOKEN } from '../../services/InjectTokens';
import { AppData } from '../AppData';
import { BaseModel } from './BaseModel';
import { Element } from './Element';

export class Magic extends BaseModel {
  public static type = 'magic';

  @observable
  public isSaved!: boolean;

  @computed
  public get title() {
    return this.i18n.t(this.type);
  }

  @computed
  public get name() {
    return this.i18n.t(this.type);
  }

  @computed
  public get isCompleted() {
    if (this.type === MoreMagicType.DEDICATION) {
      return (
        !isEmpty(this.params) ||
        Boolean(this.meta.collection && (this.meta.collection as AppData).dedicationImage) ||
        this.isSaved
      );
    } else if (this.type === MoreMagicType.CHILD_IMAGE) {
      return Boolean(this.meta.collection && (this.meta.collection as AppData).childImage) || this.isSaved;
    } else {
      return !isEmpty(this.params) || this.isSaved;
    }
  }

  @prop
  public type!: MoreMagicType;

  @prop
  public path!: string | null;

  @prop
  public elements!: Array<Element>;

  @prop
  public params!: Record<string, string>;

  @prop
  private firstOnPage!: string;

  @computed
  public get firstAppearedOn() {
    return parseInt(this.firstOnPage, 10);
  }

  private i18n = inject(I18N_TOKEN);
}
